var __SHV_DE = (window.location.pathname.indexOf('/de/') === 0 || window.location.pathname === '/de');
/* ============================================================
   pc-configurator-ventilateur.js
   Multi-select support for "ventilateur" category (add multiple
   fans with per-item quantity). All cart/total/share/URL logic
   is now handled directly in the main pc-configurator.js — this
   sub-script only handles:
     1. selectProduct / deselectProduct to maintain an array
     2. Category sidebar render (avoid array.title crash)
     3. Per-card +/- quantity UI and selected badge count
   ============================================================ */
(function(){
  'use strict';

  function waitForExports(cb, n) {
    if (window.__ventS && window.__ventR && window.__ventC && window.__ventU && window.__ventD) return cb();
    if (n > 50) return console.warn('[VENT] Timeout waiting for exports');
    setTimeout(function(){ waitForExports(cb, (n || 0) + 1); }, 100);
  }

  waitForExports(function(){
    var STATE  = window.__ventS;
    var Render = window.__ventR;
    var CONFIG = window.__ventC;
    var Utils  = window.__ventU;
    var DOM    = window.__ventD;

    /* --- Visual styles --- */
    var s = document.createElement('style');
    s.textContent = [
      '.vent-qty-controls{display:flex;align-items:center;gap:6px;justify-content:center;margin-top:4px}',
      '.vent-qty-btn{width:28px;height:28px;border-radius:50%;border:1.5px solid #0066FF;background:#fff;color:#0066FF;font-size:16px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .15s;line-height:1;padding:0}',
      '.vent-qty-btn:hover{background:#0066FF;color:#fff}',
      '.vent-qty-val{font-size:15px;font-weight:600;min-width:20px;text-align:center;color:#222}',
      '.vent-remove-btn{display:block;width:100%;margin-top:6px;padding:6px 0;border:none;border-radius:6px;background:#fee;color:#d33;font-size:12px;font-weight:600;cursor:pointer;transition:all .15s}',
      '.vent-remove-btn:hover{background:#d33;color:#fff}',
      '.product-card.vent-selected{border:2px solid #0066FF!important;box-shadow:0 0 12px rgba(0,102,255,0.15)!important}',
      '.product-card.vent-selected .product-action{display:none!important}'
    ].join('\n');
    document.head.appendChild(s);

    function getVentArr(){ return Array.isArray(STATE.build.ventilateur) ? STATE.build.ventilateur : []; }

    /* Auto-upgrade to Premium Montage when 4+ fans are configured. Only auto-applies
       if Standard is currently selected (or nothing) — never overrides an explicit
       Premium choice or a "Je monte moi-même" choice. Marked with a flag so we don't
       loop. */
    var _autoUpgraded = false;
    function maybeAutoUpgradeMontage() {
      try {
        var ventArr = getVentArr();
        var totalFans = 0;
        for (var i = 0; i < ventArr.length; i++) totalFans += parseInt(ventArr[i].qty, 10) || 1;
        if (totalFans < 4) return;
        var current = STATE.build['config-montage'];
        var pool = STATE.products['config-montage'] || [];
        if (pool.length === 0) return;
        var premium = pool.find(function(p){
          var t = (p.title || '').toLowerCase();
          var tags = Array.isArray(p.tags) ? p.tags.join(',').toLowerCase() : '';
          return t.indexOf('premium') > -1 || tags.indexOf('premium') > -1;
        });
        if (!premium) return;
        if (current && current.variantId === premium.variantId) return;
        /* Don't override if user explicitly picked Premium or DIY; only auto-upgrade
           from "nothing selected" or from Standard */
        if (current) {
          var ct = (current.title || '').toLowerCase();
          if (ct.indexOf('premium') > -1) return;
          if (ct.indexOf('moi-même') > -1 || ct.indexOf('moi-meme') > -1 || ct.indexOf('selbst') > -1 || ct.indexOf('diy') > -1) return;
        }
        STATE.build['config-montage'] = {
          id: premium.id,
          title: premium.title,
          variantId: premium.variantId,
          price: premium.price,
          tags: premium.tags || [],
          compat: premium.compat || {}
        };
        _autoUpgraded = true;
        showAutoUpgradeToast();
      } catch(e) { console.warn('[VENT] auto-upgrade failed', e); }
    }

    function showAutoUpgradeToast() {
      var existing = document.getElementById('sh-auto-upgrade-toast');
      if (existing) existing.remove();
      var t = document.createElement('div');
      t.id = 'sh-auto-upgrade-toast';
      t.style.cssText = 'position:fixed;bottom:90px;left:50%;transform:translateX(-50%);background:linear-gradient(135deg,#0066FF,#0044CC);color:#fff;padding:14px 22px;border-radius:14px;font-size:13.5px;font-weight:600;box-shadow:0 12px 32px rgba(0,102,255,.35);z-index:10001;display:flex;align-items:center;gap:10px;max-width:92%;font-family:-apple-system,BlinkMacSystemFont,sans-serif;opacity:0;transition:opacity .3s';
      t.innerHTML = __SHV_DE ? '<span style="font-size:18px">⭐</span><div><strong style="display:block">Premium-Montage aktiviert</strong><span style="font-size:12px;opacity:.92">Empfohlen ab 4+ Lüftern (Tuning + 48h-Tests)</span></div>' : '<span style="font-size:18px">⭐</span><div><strong style="display:block">Montage Premium activé</strong><span style="font-size:12px;opacity:.92">Recommandé avec 4+ ventilateurs (tuning + tests 48h)</span></div>';
      document.body.appendChild(t);
      setTimeout(function(){ t.style.opacity = '1'; }, 50);
      setTimeout(function(){ t.style.opacity = '0'; setTimeout(function(){ t.remove(); }, 400); }, 4500);
    }

    /* Always call the main Render.updateTotal so the blue checkout bar (which
       depends on renderCheckoutButton inside updateTotal) stays in sync. */
    function afterChange() {
      maybeAutoUpgradeMontage();
      try { Render.updateTotal(); } catch(e) { console.warn('[VENT] updateTotal failed', e); }
      try { Render.categories(); } catch(e) { console.warn('[VENT] categories failed', e); }
      try { Render.renderNextButton(); } catch(e) {}
      try { Render.products(); } catch(e) {}
      try { Utils.setUrlParams(STATE.build); } catch(e) {}
      /* Reset the signature so applyVentUI is guaranteed to re-paint */
      _lastVentSig = '__force__';
      setTimeout(applyVentUI, 30);
      setTimeout(applyVentUI, 150);
      setTimeout(applyVentUI, 400);
    }

    function removeFan(pid){
      pid = parseInt(pid, 10);
      var arr = getVentArr();
      STATE.build.ventilateur = arr.filter(function(f){ return f.id !== pid; });
      if (STATE.build.ventilateur.length === 0) delete STATE.build.ventilateur;
      afterChange();
    }

    function setFanQty(pid, qty){
      pid = parseInt(pid, 10);
      qty = parseInt(qty, 10);
      if (qty <= 0) return removeFan(pid);
      if (qty > 10) qty = 10;
      var arr = getVentArr();
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].id === pid) { arr[i].qty = qty; break; }
      }
      afterChange();
    }

    /* --- Inject +/- and Remove controls onto selected fan cards --- */
    var _applyingVentUI = false;
    var _lastVentSig = '';
    var _lastCardCount = 0;
    function applyVentUI() {
      if (STATE.activeCategory !== 'ventilateur') return;
      if (_applyingVentUI) return;
      var ventArr = getVentArr();
      var cards = document.querySelectorAll('.product-card');
      var sig = JSON.stringify(ventArr.map(function(v){return v.id + ':' + (v.qty || 1);})) + '|' + cards.length;
      if (sig === _lastVentSig && cards.length === _lastCardCount) return;
      _lastVentSig = sig;
      _lastCardCount = cards.length;
      _applyingVentUI = true;
      try { observer.disconnect(); } catch(e) {}

      for (var c = 0; c < cards.length; c++) {
        var card = cards[c];
        var pid = card.getAttribute('data-product-id');
        if (!pid) continue;
        pid = parseInt(pid, 10);
        var sel = null;
        for (var i = 0; i < ventArr.length; i++) {
          if (ventArr[i].id === pid) { sel = ventArr[i]; break; }
        }
        var old = card.querySelector('.vent-controls-wrap');
        if (old) old.remove();
        var btn = card.querySelector('.product-action');
        if (sel) {
          card.classList.add('selected', 'vent-selected');
          var ov = card.querySelector('.product-selected-overlay');
          if (ov) ov.style.display = '';
          if (btn) btn.style.display = 'none';
          var wrap = document.createElement('div');
          wrap.className = 'vent-controls-wrap';
          wrap.style.cssText = 'padding:0 10px 10px;';
          var qd = document.createElement('div');
          qd.className = 'vent-qty-controls';
          var mb = document.createElement('button');
          mb.className = 'vent-qty-btn';
          mb.textContent = '−';
          mb.setAttribute('data-pid', pid);
          mb.setAttribute('data-action', 'vent-minus');
          var qs = document.createElement('span');
          qs.className = 'vent-qty-val';
          qs.textContent = sel.qty || 1;
          var pb = document.createElement('button');
          pb.className = 'vent-qty-btn';
          pb.textContent = '+';
          pb.setAttribute('data-pid', pid);
          pb.setAttribute('data-action', 'vent-plus');
          qd.appendChild(mb); qd.appendChild(qs); qd.appendChild(pb);
          var rb = document.createElement('button');
          rb.className = 'vent-remove-btn';
          rb.textContent = '✕ Retirer';
          rb.setAttribute('data-pid', pid);
          rb.setAttribute('data-action', 'vent-remove');
          wrap.appendChild(qd);
          wrap.appendChild(rb);
          card.appendChild(wrap);
        } else {
          card.classList.remove('selected', 'vent-selected');
          var ov2 = card.querySelector('.product-selected-overlay');
          if (ov2) ov2.style.display = 'none';
          if (btn) { btn.style.display = ''; btn.textContent = __SHV_DE ? 'Hinzufügen' : 'Ajouter'; }
        }
      }
      _applyingVentUI = false;
      setTimeout(function(){ try { startObserving(); } catch(e) {} }, 80);
    }

    /* --- Click handler on +/-/remove buttons --- */
    document.addEventListener('click', function(e){
      var tgt = e.target.closest('[data-action]');
      if (!tgt) return;
      var action = tgt.getAttribute('data-action');
      var pid = tgt.getAttribute('data-pid');
      if (!pid) return;
      pid = parseInt(pid, 10);
      var arr = getVentArr();
      if (action === 'vent-minus') {
        e.preventDefault(); e.stopPropagation();
        for (var i = 0; i < arr.length; i++) if (arr[i].id === pid) { setFanQty(pid, (arr[i].qty || 1) - 1); break; }
      } else if (action === 'vent-plus') {
        e.preventDefault(); e.stopPropagation();
        for (var j = 0; j < arr.length; j++) if (arr[j].id === pid) { setFanQty(pid, (arr[j].qty || 1) + 1); break; }
      } else if (action === 'vent-remove') {
        e.preventDefault(); e.stopPropagation();
        removeFan(pid);
      }
    }, true);

    var _ventDebounce = null;
    var observer = new MutationObserver(function(){
      if (STATE.activeCategory !== 'ventilateur') return;
      clearTimeout(_ventDebounce);
      _ventDebounce = setTimeout(applyVentUI, 150);
    });
    function startObserving(){
      observer.disconnect();
      var grid = document.querySelector('.product-grid, .products-grid, .product-list, #product-grid');
      if (!grid) {
        var fc = document.querySelector('.product-card');
        grid = fc ? fc.parentElement : null;
      }
      if (grid) observer.observe(grid, { childList: true, subtree: false, attributes: false });
    }
    startObserving();

    document.querySelectorAll('[data-category]').forEach(function(btn){
      btn.addEventListener('click', function(){
        setTimeout(function(){ startObserving(); applyVentUI(); }, 500);
      });
    });

    /* --- Override selectProduct: push fan into array with qty --- */
    var _origSelect = Render.selectProduct;
    Render.selectProduct = function(category, product) {
      if (category !== 'ventilateur') return _origSelect.call(this, category, product);
      if (!Array.isArray(STATE.build.ventilateur)) STATE.build.ventilateur = [];
      var existing = null;
      for (var i = 0; i < STATE.build.ventilateur.length; i++) {
        if (STATE.build.ventilateur[i].id === product.id) { existing = STATE.build.ventilateur[i]; break; }
      }
      if (existing) {
        existing.qty = Math.min((existing.qty || 1) + 1, 10);
      } else {
        STATE.build.ventilateur.push({
          id: product.id,
          title: product.title,
          variantId: product.variantId,
          price: product.price,
          tags: product.tags || [],
          compat: product.compat || {},
          qty: 1
        });
      }
      afterChange();
    };

    var _origDeselect = Render.deselectProduct;
    Render.deselectProduct = function(category) {
      if (category !== 'ventilateur') return _origDeselect.call(this, category);
      delete STATE.build.ventilateur;
      afterChange();
    };

    /* --- Override categories: avoid array.title crash + show total qty badge --- */
    var _origCat = Render.categories;
    Render.categories = function(){
      var ventArr = getVentArr();
      var saved = STATE.build.ventilateur;
      if (ventArr.length > 0) {
        /* Pretend to the original renderer that the first fan is the single
           selected product, so it can render .title and .price safely. */
        var first = ventArr[0];
        var totalQty = 0;
        var sumPrice = 0;
        for (var k = 0; k < ventArr.length; k++) {
          var f = ventArr[k];
          totalQty += parseInt(f.qty, 10) || 1;
          var fp = typeof f.price === 'string' ? parseFloat(f.price) : (f.price || 0);
          sumPrice += fp * (parseInt(f.qty, 10) || 1);
        }
        STATE.build.ventilateur = {
          title: ventArr.length === 1 ? first.title : (first.title + ' +' + (ventArr.length - 1)),
          price: sumPrice,
          variantId: first.variantId
        };
      }
      _origCat.call(this);
      STATE.build.ventilateur = saved;

      if (ventArr.length === 0) return;
      var totalQ = 0;
      for (var i = 0; i < ventArr.length; i++) totalQ += ventArr[i].qty || 1;
      var catBtns = document.querySelectorAll('[data-category="ventilateur"]');
      for (var b = 0; b < catBtns.length; b++) {
        var badge = catBtns[b].querySelector('.vent-count-badge');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'vent-count-badge';
          badge.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;min-width:20px;height:20px;border-radius:10px;background:#0066FF;color:#fff;font-size:11px;font-weight:700;margin-left:6px;padding:0 5px;';
          catBtns[b].appendChild(badge);
        }
        badge.textContent = totalQ;
      }
    };

    console.log('[VENT] Multi-select v4 loaded (main JS owns total/cart/share)');
  });
})();
